import {
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import {
  CheckoutSessionRequest,
  CheckoutSessionResponse,
} from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export const createCheckoutSession = async (
  data: CheckoutSessionRequest,
): Promise<CheckoutSessionResponse> => {
  return await tinctApi.subscriptions.createCheckoutSession(data);
};

export const useCreateCheckoutSession = (
  options?: Omit<
    UseMutationOptions<CheckoutSessionResponse, ApiError, CheckoutSessionRequest>,
    'mutationFn'
  >,
) => {
  return useMutation<CheckoutSessionResponse, ApiError, CheckoutSessionRequest>({
    mutationFn: createCheckoutSession,
    ...options,
  });
};
